
import React, { Component } from "react";
import { Button, Form,  Row } from "react-bootstrap";
import configData from "../config.json";
import { toast } from "react-toastify";
import "./Abha.css";
import ReCAPTCHA from 'react-google-recaptcha';

export default class Abhaaddressverfiotp extends Component {
  constructor(props) {
    super(props);
   this.recaptchaRef = React.createRef();
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      abhaAddress: sessionStorage.getItem("abhaAddress"),
      otpResponseMsg:sessionStorage.getItem("otpResponseMsg") || "",
      abhaotp: ["", "", "", "", "", ""],
      abhaaddressotp: ["", "", "", "", "", ""],
      AbhaProfile: {},
      mobile: "",
      showOtp: false,
      showAbha: false,
      showAbhaAddress: false,
      showAddessotp: false,
      cabhaaddress: "",
      custshowAddess: false,
      isAbhaVerifiedReady: false,
      authMethods: "",
      resendTimer: 60, // 10 minutes
      resendEnabled: false,
      resendIntervalId: null,
      captchaToken:null,
      // ["aadhaarotp", "mobileotp"]
    };
  }
  handleCaptchaChange = (value) => {
    this.setState({
      captchaToken: value,
    });
  };
  resetCaptcha = () => {
    this.setState({ captchaToken: "" });
    if (this.recaptchaRef && this.recaptchaRef.current) {
      this.recaptchaRef.current.reset();
    }
  };
  formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };
  startResendCountdown = () => {
    this.setState({
      resendEnabled: false,
      resendOtpABAVeCount:
        parseInt(sessionStorage.getItem("resendOtpABAVeCount")) || 0,
      resendTimer: 60,
    });
    const intervalId = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.resendTimer <= 1) {
          clearInterval(this.state.resendIntervalId);
          return { resendEnabled: true, resendTimer: 0 };
        }
        return { resendTimer: prevState.resendTimer - 1 };
      });
    }, 1000);
    this.setState({ resendIntervalId: intervalId });
  };
 
  ResendOTP = (e) => {
    e.preventDefault();
    let resendCount =
      parseInt(sessionStorage.getItem("resendOtpABAVeCount")) || 0;
    if (resendCount >= 2) {
      this.showToast("Maximum resend attempts reached.", "error");
      return;
    }
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);

    fetch(configData.api_url + "C_Abhaaddress/resendAbhaAddressOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        const isValid =
          data.status === "success" &&
          data.requestId && data.requestId !== 0 &&
          (!data.details ||
             !data.details[0]?.message?.includes("Invalid"));
  
        if (isValid) {
          resendCount++;
          sessionStorage.setItem("resendOtpABAVeCount", resendCount);
          clearInterval(this.state.resendIntervalId);
          this.startResendCountdown();
           this.showToast("OTP resent successfully.");
        } else {
          const errorMsg =
            data?.details?.[0]?.message || data.message || "OTP resend failed. Please try again.";
             this.showToast(errorMsg, "error");
        }
      })
     
  };
  componentDidMount() {
    this.ResponseHandler();
    if (!sessionStorage.getItem("resendOtpABAVeCount")) {
      sessionStorage.setItem("resendOtpABAVeCount", "0");
    }
    this.startResendCountdown();
    // this.startResendTimer();
  }
  ResponseHandler = () => {
    var formData = new FormData();

    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhaaddress/retriverequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.detail && data.detail.abhaprofile) {
          const abhaDetails = JSON.parse(data.detail.abhaprofile);
          const abhaProfile = abhaDetails.ABHAProfile;
          if (abhaProfile)
            this.setState({
              AbhaProfile: abhaProfile,
            });
        }
      });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
       case "warning":
      toast.danger(msg);
        break;
     default:toast.success(msg);
    }
  };
  handleImageClick = (option) => {
    this.setState({ authMethods: option });
  };

  handleabhaaddressotpChange = (e, index) => {
    const val = e.target.value;
    if (/^\d?$/.test(val)) {
      this.setState(
        (prevState) => {
          const newOtp = [...prevState.abhaaddressotp];
          newOtp[index] = val;
          return { abhaaddressotp: newOtp };
        },
        () => {
          // auto focus next input if a digit was entered
          if (val && index < 5) {
            this[`otpInput1${index + 1}`].focus();
          }
        }
      );
    }
  };

  handleABHAAddressSearchNext = (e) => {
    e.preventDefault();
    const { abhaAddress, authMethods } = this.state;
    if (!authMethods) {
      this.showToast("Please select Aadhaar or Mobile OTP option.", "error");
      return;
    }
    sessionStorage.setItem("abhaAddress", abhaAddress);
    const formData = new FormData();
    formData.append("abhaAddress", abhaAddress);
    formData.append("authMethods", authMethods);
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhaaddress/getAuthMethodsByabhaAddress", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast(data.message, data.status);
          sessionStorage.setItem("message", data.message);
          sessionStorage.setItem("resendOtpABAVeCount", "");
          this.setState({ isAbhaVerifiedReady: true }); // changed from data.details.message
        } else {
          this.showToast(data.message || "Something went wrong", "error");

          this.setState({
            resendOtpABAVeCount: "",
          });
        }
      });
  };
  handleABHAAddressSubmitNext = (e) => {
    e.preventDefault();
    const { abhaAddress, authMethods ,captchaToken} = this.state;

    sessionStorage.setItem("abhaAddress", abhaAddress);
    if (!captchaToken) {
       this.showToast('Please verify that you are not a robot!',"error");
      return;
    }
    const formData = new FormData();
    formData.append("abhaAddress", abhaAddress);
    formData.append("authMethods", authMethods);
    formData.append("captchaToken", captchaToken);
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhaaddress/submitAbhaAddress", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({
            otpResponseMsg: data.details.message, // store message for <p> tag
            responseMessage: "",
            showMessage: false,
          });
          this.showToast(data.message, "success");
        } else {
          this.setState({
            responseMessage: data?.details?.message || data.message,
            showMessage: true,
          });
          this.showToast(data.message || "Something went wrong", "error");
        }
      })
     
  };
  // handleSubmitAddressOTPNext = (e) => {
  //   e.preventDefault();
  //   const { captchaToken } = this.state;
  //   const abhaaddressotp = this.state.abhaaddressotp.join("");
  
  //   if (!captchaToken) {
  //     this.showToast("Please verify that you are not a robot!", "error");
  //     return;
  //   }
  
  //   sessionStorage.setItem("abhaotp", this.state.abhaaddressotp);
  
  //   var formData = new FormData();
  //   formData.append("captchaToken", captchaToken);
  //   formData.append("abhaaddressotp", abhaaddressotp);
  //   formData.append("requestId", sessionStorage.getItem("requestId"));
  
  //   fetch(configData.api_url + "C_Abhaaddress/submitAbhaAddressOtp", {
  //     method: "POST",
  //     mode: "cors",
  //     body: formData,
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       this.showToast(data.message, data.status);
  
  //       if (data.status === "success") {
  //         // check if KYC verified
  //         if (data.details && data.details.kycStatus === "VERIFIED") {
  //           sessionStorage.setItem("requestId", data.requestId);
  //           this.setState({
  //             resendOtpABAVeCount: "",
  //           });
  //           setTimeout(() => {
  //            window.location.href = "./abhaaddressprofile";
  //           }, 5000);
  //         } 
  //         else {
  //           this.showToast(
  //             "This is a non-KYC ABHA address. Please link your ABHA address to your ABHA number to enable download.",
  //             "error"
  //           );
  //         }
  //       }
  //     });
  // };
  

      handleSubmitAddressOTPNext = (e) => {
      e.preventDefault();
      const {captchaToken}=this.state
      const abhaaddressotp = this.state.abhaaddressotp.join("");
      if (!captchaToken) {
        this.showToast('Please verify that you are not a robot!',"error");
        return;
      }
      sessionStorage.setItem("abhaotp", this.state.abhaaddressotp);
      var formData = new FormData();
      formData.append("captchaToken", captchaToken);
      formData.append("abhaaddressotp", abhaaddressotp);
      formData.append("requestId", sessionStorage.getItem("requestId"));

      fetch(configData.api_url + "C_Abhaaddress/submitAbhaAddressOtp", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => { 
          this.showToast(data.message, data.status);
          if (data.status === "success") {
            sessionStorage.setItem("requestId", data.requestId);
            this.showToast(data.message);
            this.setState({
              resendOtpABAVeCount: "",
            });
            setTimeout(() => {
              window.location.href="./abhaaddressprofile"
            }, 5000);
          
          }
        
        
        
        });
    };

  
  onKeyDownONE = (e, idx) => {
    if (e.key === "Backspace" && !this.state.abhaaddressotp[idx] && idx > 0) {
      this[`otpInput1${idx - 1}`].focus();
    }
  };
  handleabhaaddressChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ abhaAddress: fieldValue });
  };

  HandleClick = () => {
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhaaddress/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
        }
        this.setState({
          isSubmitting: false,
        });
      });
  };

  HandleNextSubmit = () => {
    window.location.href = "/abhaprofile";
  };
  HandleNewClick = () => {
 
    sessionStorage.setItem("resendOtpABAVeCount", "");

    window.location.href = "/download";
  };
  handlenextClick = () => {
    const { abhanumber, aadharNumber } = this.state;
    sessionStorage.setItem("abhaAddress", this.state.AbhaProfile.phrAddress);
    sessionStorage.setItem("aadharNumber", aadharNumber);
    sessionStorage.setItem("abhanumber", abhanumber);

    window.location.href = "/abhaprofile ";
  };

  render() {
    const {  
      abhaaddressotp,
      showAddessotp,
     resendEnabled,
      resendTimer,otpResponseMsg
    } = this.state;
    return (
      <div>
    

        <div className="row justify-content-md-center text-center abhaAddressVerificationSection">
          <div className="col-md-6 mt-3">
            <div className="widget_BG widget_BG_grid mb-2">
       
              <Form.Group className="abhaaddressverificationOTP">
                <Form.Label>
                <i style={{ color: "blue" }}>
                      OTP has been sent to this Mobile number&nbsp;
                      {otpResponseMsg ? "******" + otpResponseMsg.slice(-4) : ""}
                    </i>
               
                </Form.Label>
                <div className="d-flex gap-2">
                  {abhaaddressotp.map((digit, idx) => (
                    <Form.Control
                      key={idx}
                      type={this.state.showAddessotp ? "text" : "password"}
                      name="abhaaddressotp"
                      id="abhaaddressotp"
                      maxLength={1}
                      onKeyDown={(e) => this.onKeyDownONE(e, idx)}
                      value={digit}
                      ref={(input) => (this[`otpInput1${idx}`] = input)}
                      className="form-control"
                      onChange={(e) => this.handleabhaaddressotpChange(e, idx)}
                    />
                  ))}

                  <Button
                    variant="outline-secondary"
                    className={`rounded-0 bi ${
                      this.state.showOtp ? "bi-eye-slash" : "bi-eye"
                    }`}
                    onClick={() =>
                      this.setState({ showAddessotp: !showAddessotp })
                    }
                  />
                </div>
                <div as={Row}>
                  <div className="col">
                    {parseInt(sessionStorage.getItem("resendOtpABAVeCount")) >=
                    2 ? (
                      <div style={{ color: "red", fontWeight: "bold" }}>
                      You’ve reached the maximum resend attempts.
                    </div>
                    ) : (
                      <>
                      <Button
                        className="rounded-0 m-3"
                        variant="warning"
                        onClick={this.ResendOTP}
                        disabled={!resendEnabled}
                      >
                        Resend OTP{" "}
                        {!resendEnabled &&
                         `in ${this.formatTime(resendTimer)}`}
                      </Button>
                      <div style={{ fontSize: "12px", color: "gray" }}>
                        Resend OTP Send Only 2 Times in a Session You have used &nbsp;.
                        {sessionStorage.getItem("resendOtpABAVeCount")|| 0} Out of 2.
                      </div>
                      </>
                    )}
                  </div>
                            <div className="col mt-3">
                            
                            <div className="d-flex">   <ReCAPTCHA 
                    className="mt-4"
                    ref={this.recaptchaRef} 
                    sitekey= {configData.captchaKey}
                    onChange={this.handleCaptchaChange}
                    /> 
                    <Button variant="secondary"  className="bi bi-arrow-clockwise re-chaptue" 
                            onClick={() => this.recaptchaRef.current.reset()}/>
                    </div>
                              
                            </div>
                </div>
              </Form.Group>
            </div>
          </div>
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2">
        <div className="col text-start">
        <Button className="rounded-0" variant="warning" onClick={this.HandleNewClick}>
              Back
            </Button>
            </div>
          <div className="col text-end">
          
            <Button
                                className="rounded-0"
                                disabled={
                                    abhaaddressotp.some((d) => d === "") ||
                                    abhaaddressotp.length !== 6
                                }
                                onClick={this.handleSubmitAddressOTPNext}
                                >
                                {this.state.isSubmitting
                                    ? "Submitting..."
                                    : "Verify\u00A0ABHA\u00A0OTP"}
                                </Button>
      
          </div>
        </div>
      </div>
    );
  }
}
